define('OutSystems/ReactWidgets/Link',["require", "exports", "tslib", "OutSystems/ClientRuntime/Navigation", "OutSystems/ClientRuntime/Settings", "OutSystems/ReactView/Widget", "query-string", "react", "react-router-dom", "./Utils"], function (require, exports, tslib_1, Navigation, Settings_1, Widget_1, querystring, React, react_router_dom_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Link = void 0;
    var Link = (function (_super) {
        tslib_1.__extends(Link, _super);
        function Link() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handleClickForAction = function (event) {
                event.preventDefault();
                event.stopPropagation();
                var onClick = _this.props.onClick;
                var click = function () { return _this.executeWithActiveClassOn(function () { return onClick === null || onClick === void 0 ? void 0 : onClick(); }); };
                if (_this.props.confirmationMessage && _this.props.confirmationMessage.length) {
                    var notification = navigator.notification;
                    if (notification) {
                        notification.confirm(_this.props.confirmationMessage, function (button) {
                            if (button === 1) {
                                click();
                            }
                        }, "");
                    }
                    else if (window.confirm(_this.props.confirmationMessage)) {
                        click();
                    }
                }
                else {
                    click();
                }
            };
            _this.handleKeyDownForAction = function (event) {
                if (event.key === Utils_1.KeyboardKey.SPACE_KEY) {
                    event.preventDefault();
                }
            };
            _this.handleKeyUpForAction = function (event) {
                if (event.key === Utils_1.KeyboardKey.SPACE_KEY) {
                    _this.handleClickForAction(event);
                }
            };
            _this.handleClickForUrl = function (event) {
                event.stopPropagation();
            };
            return _this;
        }
        Link.prototype.render = function () {
            var _a;
            var _b = this.props, url = _b.url, enabled = _b.enabled, style = _b.style, transition = _b.transition, children = _b.children;
            var linkAttributes = {
                "data-link": "",
                className: style,
                disabled: !enabled,
                href: undefined,
            };
            if (enabled) {
                if (url) {
                    linkAttributes.onClick = this.handleClickForUrl;
                    var urlInfo = Navigation.getUrlInfo(url);
                    if (urlInfo.isInternal) {
                        linkAttributes.to = {
                            pathname: urlInfo.path,
                            search: Object.keys((_a = urlInfo.queryParams) !== null && _a !== void 0 ? _a : {}).length > 0
                                ? "?".concat(querystring.stringify(urlInfo.queryParams, { sort: false }))
                                : "",
                            state: {
                                transition: transition,
                            },
                        };
                        linkAttributes.activeClassName = "active";
                        linkAttributes.isActive = function (match, location) {
                            if (!match) {
                                return false;
                            }
                            return match.isExact && linkAttributes.to.search === location.search;
                        };
                        this.fillWithBuiltinProperties(linkAttributes);
                        return React.createElement(react_router_dom_1.NavLink, tslib_1.__assign({}, linkAttributes), children);
                    }
                    else {
                        linkAttributes.href = url;
                    }
                }
                else {
                    linkAttributes.onClick = this.handleClickForAction;
                    linkAttributes.href = "#";
                    if ((0, Settings_1.getEnvParams)().EnableWCAG22) {
                        linkAttributes.role = "button";
                        linkAttributes.onKeyDown = this.handleKeyDownForAction;
                        linkAttributes.onKeyUp = this.handleKeyUpForAction;
                    }
                }
            }
            this.fillWithBuiltinProperties(linkAttributes);
            return React.createElement("a", tslib_1.__assign({}, linkAttributes), children);
        };
        Link = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Link);
        return Link;
    }(Widget_1.Widget));
    exports.Link = Link;
});
//# sourceMappingURL=Link.js.map;
